import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Custom red palette matching ui.mantine.dev red theme
const atlasRed: MantineColorsTuple = [
  '#fff1f1',
  '#ffe0e0',
  '#ffc7c7',
  '#ffa3a3',
  '#ff6b6b',
  '#ff3b3b',
  '#f03e3e',
  '#c92a2a',
  '#a52525',
  '#862020',
];

export const atlasTheme = createTheme({
  primaryColor: 'red',
  colors: {
    red: atlasRed,
  },
  primaryShade: { light: 6, dark: 7 },
  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
  fontFamilyMonospace: 'JetBrains Mono, ui-monospace, monospace',
  headings: {
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
    fontWeight: '700',
  },
  defaultRadius: 'md',
  cursorType: 'pointer',
  components: {
    Button: {
      defaultProps: {
        variant: 'filled',
      },
    },
    Paper: {
      defaultProps: {
        shadow: 'sm',
        radius: 'md',
      },
    },
    Card: {
      defaultProps: {
        shadow: 'sm',
        radius: 'md',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    PasswordInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
        comboboxProps: { shadow: 'md', radius: 'md' },
      },
    },
    Autocomplete: {
      defaultProps: {
        radius: 'md',
        comboboxProps: { shadow: 'md', radius: 'md' },
      },
    },
    Modal: {
      defaultProps: {
        radius: 'md',
        centered: true,
      },
    },
    NavLink: {
      defaultProps: {
        variant: 'light',
      },
    },
  },
});
